import { Plus } from 'lucide-react-native';
import { Pressable, StyleSheet } from 'react-native';

import { Text } from '@/components/Text';
import { colors, radii, spacing } from '@/constants/theme';

export type UploadAddBoxProps = {
  onPress: () => void;
  disabled?: boolean;
  testID?: string;
};

/** Under the picked videos: the dashed "Add another video" row, so more can join before Submit. */
export function UploadAddBox({ onPress, disabled, testID }: UploadAddBoxProps) {
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      accessibilityRole="button"
      accessibilityLabel="Add another video, from your camera roll"
      accessibilityState={{ disabled: !!disabled }}
      style={({ pressed }) => [styles.box, disabled && styles.disabled, pressed && styles.pressed]}
      testID={testID}
    >
      <Plus size={18} color={colors.deepGreen} strokeWidth={2.25} />
      <Text variant="bodyBold" color="deepGreen">
        Add another video
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  // The pick box's dashed border, one line tall.
  box: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
    minHeight: 56,
    borderRadius: radii.lg,
    borderWidth: 2,
    borderStyle: 'dashed',
    borderColor: colors.trackMutedFill,
    backgroundColor: colors.surface,
  },
  disabled: { opacity: 0.5 },
  pressed: { opacity: 0.7 },
});
